// import { connect } from 'react-redux';
import CmsNavigation from '../../../components/molecules/cmsNavigation/CmsNavigation';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import PropTypes from 'prop-types';
import React from 'react';

const CmsNavigationTastic = ({ data, node, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <CmsNavigation
      activeMenu={node.configuration.path}
      activePage={node.name}
      navigationLinks={data.navigationLinks}
    />
  );
};

CmsNavigationTastic.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.object.isRequired,
};

export default tastify({
  translate: true,
  connect: {
    node: true,
    context: true,
  },
})(CmsNavigationTastic);
